import { Link } from "@/lib/nav";
import { ReactNode } from "react";

import { Button } from "@buildpy/ui/button";
import PrintButton from "@/modules/print/print-button";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  closeHref: string;
  printable?: boolean;
  children: ReactNode;
}

// 인쇄 미리보기 틀 — 앱 셸을 덮고, 인쇄할 때는 print-hide 머리줄이 빠지고 globals.css 의 .print-root 만 종이에 남는다. 폰 A4 축소(A4Fit)는 호출부가 종이에만 건다.
const PrintPreviewShell = ({ title, subtitle, closeHref, printable = true, children }: Props) => (
  <div className="fixed inset-0 z-50 overflow-auto bg-muted">
    <div className="print-hide sticky top-0 z-10 flex items-center justify-between gap-2 border-b border-border bg-card px-4 pb-2.5 pt-safe-2.5">
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold">{title}</p>
        {subtitle && <p className="truncate text-xs text-muted-foreground">{subtitle}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-x-2">
        <Button asChild size="sm" variant="ghost">
          <Link href={closeHref}>닫기</Link>
        </Button>
        {printable && <PrintButton />}
      </div>
    </div>

    <div className="print-root px-2 py-4 md:px-4">
      {children}
    </div>
  </div>
);

export default PrintPreviewShell;
